import SectionHeading from '@/components/feature/SectionHeading';
import { synopsisParagraphs } from '@/mocks/home';

const facts = [
  { label: '题材', value: '都市情感 · 悬疑反转' },
  { label: '结构', value: '高频反转 · 短集连看' },
  { label: '基调', value: '冷暖对冲 · 氛围感强' },
  { label: '适合人群', value: '喜欢快节奏与情绪拉扯的观众' },
];

export default function Synopsis() {
  return (
    <section id="intro" className="w-full bg-background-50 py-14 md:py-20">
      <div className="px-4 md:px-6 max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-[1.5fr,1fr] gap-10 lg:gap-16 items-start">
        <div>
          <SectionHeading
            eyebrow="Synopsis"
            title="剧情梗概：一场被精心安排的相遇"
            desc="从一次看似偶然的相遇出发，看欲望与真心如何在同一条路上互相拉扯。"
          />
          <div className="mt-6 space-y-4 text-sm md:text-base text-foreground-700 leading-relaxed">
            {synopsisParagraphs.map((p) => (
              <p key={p.slice(0, 12)}>{p}</p>
            ))}
          </div>
          <p className="mt-6 flex items-start gap-2 text-xs md:text-sm text-foreground-500 bg-secondary-50 border border-secondary-200 rounded-lg px-4 py-3">
            <i className="ri-information-line mt-0.5 text-secondary-600" aria-hidden="true" />
            本节为题材向梗概与浏览索引，用于帮助理解整体基调，具体剧情与集数以实际发布版本为准。
          </p>
        </div>

        <aside className="rounded-lg border border-background-200 bg-background-100 p-5 md:p-6">
          <h3 className="font-heading text-lg font-bold text-foreground-950">剧集信息速览</h3>
          <dl className="mt-5 divide-y divide-background-200">
            {facts.map((f) => (
              <div key={f.label} className="flex items-start justify-between gap-4 py-3">
                <dt className="text-sm text-foreground-500 font-label shrink-0">{f.label}</dt>
                <dd className="text-sm text-foreground-900 text-right">{f.value}</dd>
              </div>
            ))}
          </dl>
          <a
            href="#episodes"
            className="mt-5 inline-flex w-full items-center justify-center gap-2 px-4 py-2.5 rounded-md bg-primary-600 text-primary-50 text-sm font-label whitespace-nowrap hover:bg-primary-700 transition-colors"
          >
            <i className="ri-arrow-down-line" aria-hidden="true" />
            直接查看剧集列表
          </a>
        </aside>
      </div>
    </section>
  );
}